import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { SectionHeader } from "../../../Common/SharedComponents";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import {
    getChooseAssetsToSwitchTable,
    getSellableAssets,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { EditIncomeDrawdownAction } from "../../Actions/EditIncomeDrawdownAction";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DrawdownPriceLock } from "../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { CrystallizationPerContribution } from "../../../Common/SIPP/DrawdownDetails/CrystallizationPerContribution";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import {
    ChooseAssetsToSellAssets,
    ChooseAssetsToSwitchAssets,
} from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { GetRegularCrystallisationAction } from "../../../CancelRegularCrystallisationWizard/Actions/GetRegularCrystallisationAction";
import { RegularDrawdown } from "../../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { StandardRegularDrawdown } from "../../../../../../../Wrap/Models/Domains/Drawdown/StandardRegularDrawdown";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { DeferredFundWarningMessage, IsRestrictedToPensionContributionWarningText, drawdownDetailsMessage } from "../../../Common/Resource/Contents";
import { ExistingContributionDispatcher } from "../../Stores/Variable";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { SecurityType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { TrueFalseRadio } from "../../../AddClient/Components/SharedComponents";
import { AllowanceDetails } from "../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { PCLSSection } from "../../../Common/SIPP/DrawdownDetails/PCLSSection";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { PaymentMethod } from '../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod';
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    regularDrawdown: RegularDrawdown;
    standardRegularDrawdown: StandardRegularDrawdown;
    CustomerPensionProtectionDetail: CustomerPensionProtectionModel;
    assetsToSwitchTable: ChooseAssetsToSwitchAssets[];
    TailoreddrawdownPermittable: boolean;
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            assetsToSwitchTable: [],
            regularDrawdown: null,
            standardRegularDrawdown: null,
            CustomerPensionProtectionDetail: null,
            TailoreddrawdownPermittable: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];

        getSellableAssets(this.props.data.Contribution.Type, hierarchyId, subAccountHierarchyId, (result) => {
            this.setState({ assetsTable: result.assetsToSell });
            this.setState({
                assetsToSwitchTable: getChooseAssetsToSwitchTable(this.props.data.Contribution, result.assetsToSwitch),
            });
        });

        this.createAndLoadDrawdownInstruction(this.props.data);

        EditIncomeDrawdownAction.getStandardRegularDrawdown(hierarchyId, (result) =>
            this.setState({ standardRegularDrawdown: result })
        );

        this.checkDeferredFunds(this.state.assetsTable);

        const params = getQueryParameters();
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            0,
            (data: ClientTradableInvestments) => {
                const result = data.CurrentIndividualHoldings.filter(
                    (ele) =>
                        ele.CurrQuantity > 0 &&
                        ele.MarketValue?.Amount > 0 &&
                        ele.SecurityType == SecurityType.OffPlatform
                ).every((ele) => ele.Permittailoreddrawdown == true);
                this.setState({ TailoreddrawdownPermittable: result });
            }
        );
    }

    private checkDeferredFunds(assets: ChooseAssetsToSellAssets[]) {
        let deferredInstrumentCodes = assets.filter((a) => a.IsDeferred).map((o) => o.Assets);
        let message = DeferredFundWarningMessage.CannotSwitchFromDeferredFundWarning.replace(
            "<InstrumentCode>",
            deferredInstrumentCodes.join(",")
        );
        this.props.showErrorMsgPopUp([message]);
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (this.state.TailoreddrawdownPermittable == false && this.state.originType == DrawdownType.Regular) {
            return false;
        }

        if (
            this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.Contribution?.DrawdownModel?.DrawdownCalculations?.HasFailedStandaloneLumpSumValidation
        ) {
            return false;
        }

        if (
            this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.Contribution?.DrawdownModel?.DrawdownCalculations?.HasStopWarning
        ) {
            return false;
        }

        return flag && !isRestrictedProtection;
    }

    private createAndLoadDrawdownInstruction(data: PensionContributionModel) {
        this.setState({ isLoading: true });

        DrawdownCalculationAction.postDrawdown(
            this.props.data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                const hierarchyId = getQueryParameters()["hierarchyid"];
                const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
                const type = Number(getQueryParameters()["type"]);

                EditIncomeDrawdownAction.getInstruction(
                    data?.Contribution?.HierarchyId,
                    type,
                    hierarchyId,
                    subAccountHierarchyId,
                    this.props.data.ClientDetails.ActorId,
                    (result) => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                        
                        ExistingContributionDispatcher.dispatch({
                            actionType: ActionType.Success,
                            payload: result,
                        });

                        GetRegularCrystallisationAction.getRegularCrystallisation(hierarchyId, (regularDrawdownResult) => {
                            this.setState({ regularDrawdown: regularDrawdownResult });     
                            this.initialiseRegularDrawdownInstruction(result, regularDrawdownResult);
                        });
                    }
                );
            },
            false,
            true,
            true
        );
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: data.Contribution.ExistingPensionSubAccountHierarchyId,
        };
    };

    private initialiseRegularDrawdownInstruction = (data: PensionContributionModel, regularDrawdown: RegularDrawdown) => {
        data.Contribution.DrawdownModel = data.Contribution.DrawdownModel || {};
        data.Contribution.DrawdownModel.RegularCrystallisationDetails = 
            data.Contribution.DrawdownModel.RegularCrystallisationDetails || {};
        data.Contribution.DrawdownModel.Income = data.Contribution.DrawdownModel.Income || {};

        data.Contribution.DrawdownModel.Income.PaymentMethod = PaymentMethod.Bacs;
        data.Contribution.DrawdownModel.DrawdownType = DrawdownType.Regular;

        if (regularDrawdown) {
            data.Contribution.DrawdownModel.RegularCrystallisationDetails.Amount = regularDrawdown.ProposedCrystallisation;
            data.Contribution.DrawdownModel.RegularCrystallisationDetails.Frequency = regularDrawdown.Frequency;
            data.Contribution.DrawdownModel.RegularCrystallisationDetails.FirstPaymentDay = regularDrawdown.NextPaymentDate;
        }

        EditIncomeDrawdownAction.saveInstruction(2, data, this.props.data.ClientDetails.ActorId, () => {
            this.setState({ isLoading: false });
        });

    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        let _data = JSON.parse(JSON.stringify(this.props.data));
        
        EditIncomeDrawdownAction.saveInstruction(2, _data, this.props.data.ClientDetails.ActorId, () => {
            this.setState({ isLoading: false });
        });
    };

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        // const isImmediateTaxFreeLumpSum =
        //     data?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
        //         ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.Npr)}
                >
                    <h2>Drawdown details</h2>
                    {this.state.TailoreddrawdownPermittable == false &&
                        data?.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                            <Alert
                                alertType={AlertType.Error}
                                message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage}
                            />
                        )}
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            <PensionProtection
                                {...this.props}
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                process={ProcessType.EditIncomeDrawdown}
                            />
                            <ProtectionInformation
                                {...this.getComponentProps(data, onChange)}
                                process={ProcessType.EditIncomeDrawdown}
                                pensionProtection={data?.Contribution?.PensionProtection}
                            />
                        </>
                    )}
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            {SectionHeader("Drawdown type")}
                            <div className="row">
                                <span className="col-4 h4">{"Drawdown type"}</span>
                                <span className="col-4" data-test="option">
                                    {data?.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Regular &&
                                        "Tailored drawdown option"}
                                </span>
                            </div>

                            <NumberTextBoxEditor
                                label="Aunuity purchase age"
                                cssWrapper="control-size-245"
                                // value={this.state.standardRegularDrawdown.Preconditions.AnnuityPurchaseAge}
                                value={75}
                                disabled={false}
                                maxNumberOfDecimalPlaces={{
                                    errorMessage: "only allow Integer",
                                    value: 0,
                                }}
                            ></NumberTextBoxEditor>
                            {
                                <RegularCrystallisation
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.EditIncomeDrawdown}
                                    doCalculation={() => this.doCalculation()}
                                    hierarchyId={data.Contribution.ExistingPensionSubAccountHierarchyId}
                                />
                            }
                            {(data?.Contribution?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.Contribution?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.Contribution?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.Contribution?.PensionProtection) && (
                                    <>
                                        <LTABreakdownDetails
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.EditIncomeDrawdown}
                                            lessThan75={ageLessThan75}
                                            hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                        />
                                    </>
                                )}
                            
                            <AllowanceDetails
                                doCalculation={() => this.doCalculation()}
                                {...this.getComponentProps(data, onChange)}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                process={ProcessType.EditIncomeDrawdown}
                            />
                            <PCLSSection
                                {...this.getComponentProps(data, onChange)}
                                data={data.Contribution.DrawdownModel}
                            />
                            <TaxFreeLumpSumPayment
                                doCalculation={this.doCalculation}
                                process={ProcessType.EditIncomeDrawdown}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                {...this.getComponentProps(data, onChange)}
                                lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                            />
                            {
                                //PensionType == PensionType.ImmediateTaxFreeLumpSum &&
                                <CrystallizationPerContribution
                                    {...this.getComponentProps(data, onChange)}
                                    modelData={this.props.data?.Contribution}
                                />
                            }
                            {data?.Contribution?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                                <DIAC
                                    {...this.getComponentProps(data, onChange)}
                                    modelData={this.props.data?.Contribution}
                                    existingAccount={false}
                                />
                            )}
                            {showChooseAssetstoSell(
                                data?.Contribution?.DrawdownModel,
                                ChooseAssetsToSellFor.Drawdown
                            ) && (
                                <>
                                    <ChooseAssetsToSell
                                        {...this.getComponentProps(data, onChange)}
                                        tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                        assets={this.state.assetsTable}
                                    />
                                    {!data?.Contribution?.DrawdownModel?.IsAcrossAllAssets && (
                                        <ChooseAssetsToSellTable
                                            modelData={data?.Contribution?.DrawdownModel}
                                            data={
                                                data?.Contribution?.DrawdownModel
                                                    ?.PensionCommencementLumpSumAllocations || []
                                            }
                                            reason={ChooseAssetsToSellFor.Drawdown}
                                            tableData={this.state.assetsTable}
                                            onRef={(ref) => this.appendChild(ref)}
                                            onChange={(v) => {
                                                this.onDataChange(
                                                    (changes) =>
                                                        this.onDataChange(onChange, changes, data, "Contribution"),
                                                    { PensionCommencementLumpSumAllocations: v },
                                                    data.Contribution,
                                                    "DrawdownModel"
                                                );
                                            }}
                                            processType={ProcessType.EditIncomeDrawdown}
                                            showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                        />
                                    )}
                                </>
                            )}
                            <OAC
                                readonly={false}
                                type={SubAccountType.Npr}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                data={{ OngoingAdviceCharge: data?.Contribution?.OngoingAdviceCharge }}
                                onRef={(ref) => this.appendChild(ref)}
                            />
                            <ChargesOnIllustration {...this.getProps("Contribution")} />
                            <hr />
                            <DrawdownPriceLock {...this.getComponentProps(data, onChange)} />
                        </>
                    )}
                </WizardLinter>
            </PartLoading>
        );
    }
}
